// Reusable 4x6 generic GS1-128 pallet/case label (contents table + (420) postal + SSCC).
// Generated by scripts/wms/generate.ts for PHP-418. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomGenericGs1128LabelFileDataSchema = yup.object().shape({
  shippingUnitType: yup.string().nullable().optional(),
  shipFromName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  shipToName: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  shipToPostalCode: yup.string().nullable().optional(),
  postalBarcode: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  bolLoadNumber: yup.string().nullable().optional(),
  proNumber: yup.string().nullable().optional(),
  unitSequence: yup.string().nullable().optional(),
  unitCount: yup.string().nullable().optional(),
  weight: yup.string().nullable().optional(),
  weightUom: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  contents: yup
    .array()
    .of(
      yup.object().shape({
        sku: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        quantity: yup.string().nullable().optional(),
        quantityUom: yup.string().nullable().optional(),
        lotCode: yup.string().nullable().optional(),
        expirationDate: yup.string().nullable().optional(),
      }),
    )
    .required(),
  sscc: yup.string().nullable().optional(),
  ssccBarcode: yup.string().nullable().optional(),
})

export type BiomGenericGs1128LabelFileData = yup.InferType<
  typeof biomGenericGs1128LabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomGenericGs1128LabelFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomGenericGs1128LabelFileMappings: RequiredFileData = {
  shippingUnitType: '1d5ba145-415f-4894-997d-8c63c29c3481',
  shipFromName: '2a2abc91-37aa-4ba1-ae72-4bff9c15c88d',
  shipFromAddress: '94f3bae0-ac86-432e-afa4-265eeb464d8b',
  shipToName: '38f9ba0c-76b5-449b-b96f-fad97d1b3877',
  shipToAddress: '603ff9da-6843-4cf9-b04e-8d98cc62b4ec',
  shipToPostalCode: 'd38a7ca7-06bc-42a1-9998-9c636dc00e67',
  postalBarcode: 'ffea7f4a-2bd9-4488-8237-da2605fd629d',
  carrier: '812f5a49-69d6-48a3-ae6f-4a8c490974be',
  bolLoadNumber: '343845f1-ffa3-4ec3-952b-30995bc70b10',
  proNumber: 'ce75638f-0646-4123-8cc5-93be7ea86cc0',
  unitSequence: 'c3099ce6-ed54-418d-b475-7a79616dd8d9',
  unitCount: 'b0d092c9-4848-4bc3-a631-1cf2f7bdbb71',
  weight: '4c934824-35eb-4c6f-9d5f-1a87d38560e7',
  weightUom: 'e48dc4d7-9545-4adb-9981-83e5390a92cc',
  poNumber: '16f0adaf-2393-4302-8011-c69d164beab7',
  contents: [
    {
      sku: '0c11eede-56c2-42df-b85a-4ddc91797e9e',
      description: '9e2311f8-eeb5-4e9b-b340-547983d4e4a4',
      quantity: '377be6fe-aba2-4c13-b3c0-e25435b599fa',
      quantityUom: '9687f99a-8f19-441d-9b69-37af71e80c54',
      lotCode: 'ca91b900-190e-4b60-925e-e0008a44d719',
      expirationDate: 'b61fc3d8-c2a6-41aa-b13f-320661aa161c',
    },
  ],
  sscc: '2d2824d9-8bf0-447a-b433-c2c5b2b90a20',
  ssccBarcode: '52456eb8-aa2b-4915-8dde-00bec19ced2e',
}
